// @flow
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { updateVisibleAirspaces } from 'actions/map';
import { toggleHUD } from 'actions/hud';
import { toggleMapLayerDrawer } from 'actions/mapLayerDrawer';

import Map from './Map';

const mapStateToProps = ({
  browser,
  hud,
  map: {
    viewport,
    visibleAirspaces,
    background,
    styleCategories,
    showAirports,
    showExtrusion,
    showAircrafts,
    selectedFeature,
  },
  router,
  drawOverlay: { appInDrawMode, mode },
  filters,
  rt: { followedAircraft },
  flags: { hasSubscription },
}) => ({
  router,
  browser,
  hud,
  filters,

  appInDrawMode,
  drawOverlayMode: mode,

  viewport,
  visibleAirspaces,
  background,
  styleCategories,
  showAirports,
  showAircrafts,
  showExtrusion,
  selectedFeature,
  followedAircraft,
  hasSubscription,
});

const mapDispatchToProps = {
  updateVisibleAirspaces,
  toggleHUD,
  toggleMapLayerDrawer,
  pushRoute: push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Map);



// WEBPACK FOOTER //
// ./components/Map/index.js